<div class="cf-chart" echarts [options]="options" *ngIf="!sparse && !allZero"></div>
<p class="cf-sparse" *ngIf="sparse">{{ 'dashboard.team.capacity_insufficient' | translate }}</p>
<p class="cf-sparse" *ngIf="allZero">{{ 'dashboard.team.capacity_none_free' | translate:{ weeks: data.horizonWeeks } }}</p>
